import { dashboard } from './dashboard';
import { campaigns } from './campaigns';
import { accounts } from './accounts';
import { org } from './org';
import { ai } from './ai';
import { rules } from './rules';
import { integrations } from './integrations';
import { reports } from './reports';
import { optimization } from './optimization';

function deepFreeze(obj) {
  Object.keys(obj).forEach((key) => {
    const val = obj[key];
    if (val && typeof val === 'object' && !Object.isFrozen(val)) deepFreeze(val);
  });
  return Object.freeze(obj);
}

export const PRISTINE_SEED = deepFreeze({
  dashboard,
  campaigns,
  accounts,
  org,
  ai,
  rules,
  integrations,
  reports,
  optimization,
});
